import * as x from '../helpers/xmlHelpers';
import * as h from '../helpers/helpers';

export class ComparableAdjustment {
    constructor(doc)
    {
		this.label = null
		this.additionalComparisonLineItemDescription = null
		this.additionalComparisonLineItemIdentifier = null
		this.comparableAdjustmentAmount = null;
		this.comparableAdjustmentType = null
		this.unitIdentifier = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.additionalComparisonLineItemDescription = x.getStringElement(doc, "./ns:AdditionalComparisonLineItemDescription");
		this.additionalComparisonLineItemIdentifier = x.getStringElement(doc, "./ns:AdditionalComparisonLineItemIdentifier");
		this.comparableAdjustmentAmount  = x.getMISMOAmountElement(doc, "./ns:ComparableAdjustmentAmount");
		this.comparableAdjustmentType = x.getStringElement(doc, "./ns:ComparableAdjustmentType");
		this.unitIdentifier = x.getStringElement(doc, "./ns:UnitIdentifier");
   }
}

export class ComparableDetail {
    constructor(doc)
    {
		this.label = null
		this.adjustedSalesPriceAmount = null;
		this.adjustedSalesPricePerBedroomAmount = null;
		this.adjustedSalesPricePerUnitAmount = null;
		this.comparableToSubjectDirectionType = null
		this.comparableWeightType = null
		this.contractAmountUnknownIndicator = null
		this.contractDateUnknownIndicator = null
		this.grossMonthlyRentMultiplierNumber = null
		this.mortgageType = null
		this.mortgageTypeOtherDescription = null
		this.noFinancingTransactionIndicator = null
		this.pricePerTotalStandardAboveGradeFinishedAreaAmount = null;
		this.pricePerUnitOfMeasureTypeForTotalFinishedAreaOfAllLivingUnitsIncludingADUAmount = null;
		this.propertyOrdinalNumber = null
		this.proximityToSubjectDistanceLinearMeasure = null
		this.salePriceNetTotalAdjustmentAmount = null;
		this.saleToListPriceRatioPercent = null
		this.sameBuilderAsSubjectIndicator = null
		this.sameProjectAsSubjectIndicator = null

		this.label = x.getStringAttribute(doc,"xlink:label");
		this.adjustedSalesPriceAmount  = x.getMISMOAmountElement(doc, "./ns:AdjustedSalesPriceAmount");
		this.adjustedSalesPricePerBedroomAmount  = x.getMISMOAmountElement(doc, "./ns:AdjustedSalesPricePerBedroomAmount");
		this.adjustedSalesPricePerUnitAmount  = x.getMISMOAmountElement(doc, "./ns:AdjustedSalesPricePerUnitAmount");
		this.comparableToSubjectDirectionType = x.getStringElement(doc, "./ns:ComparableToSubjectDirectionType");
		this.comparableWeightType = x.getStringElement(doc, "./ns:ComparableWeightType");
		this.contractAmountUnknownIndicator = x.getBooleanElement(doc, "./ns:ContractAmountUnknownIndicator");
		this.contractDateUnknownIndicator = x.getBooleanElement(doc, "./ns:ContractDateUnknownIndicator");
		this.grossMonthlyRentMultiplierNumber = x.getNumericElement(doc, "./ns:GrossMonthlyRentMultiplierNumber");
		this.mortgageType = x.getStringElement(doc, "./ns:MortgageType");
		this.mortgageTypeOtherDescription = x.getStringElement(doc, "./ns:MortgageTypeOtherDescription");
		this.noFinancingTransactionIndicator = x.getBooleanElement(doc, "./ns:NoFinancingTransactionIndicator");
		this.pricePerTotalStandardAboveGradeFinishedAreaAmount  = x.getMISMOAmountElement(doc, "./ns:PricePerTotalStandardAboveGradeFinishedAreaAmount");
		this.pricePerUnitOfMeasureTypeForTotalFinishedAreaOfAllLivingUnitsIncludingADUAmount  = x.getMISMOAmountElement(doc, "./ns:PricePerUnitOfMeasureTypeForTotalFinishedAreaOfAllLivingUnitsIncludingADUAmount");
		this.propertyOrdinalNumber = x.getIntegerElement(doc, "./ns:PropertyOrdinalNumber");
		this.proximityToSubjectDistanceLinearMeasure = x.getMISMOMeasureElement(doc, "./ns:ProximityToSubjectDistanceLinearMeasure");
		this.salePriceNetTotalAdjustmentAmount  = x.getMISMOAmountElement(doc, "./ns:SalePriceNetTotalAdjustmentAmount");
		this.saleToListPriceRatioPercent = x.getStringElement(doc, "./ns:SaleToListPriceRatioPercent");
		this.sameBuilderAsSubjectIndicator = x.getBooleanElement(doc, "./ns:SameBuilderAsSubjectIndicator");
		this.sameProjectAsSubjectIndicator = x.getBooleanElement(doc, "./ns:SameProjectAsSubjectIndicator");
   }
}

export class Comparable {
    constructor(doc)
    {
		this.label = null
		this.comparableAdjustments = []
		this.comparableDetail = null
		var node;
		var nodes;

		this.label = x.getStringAttribute(doc,"xlink:label");
		nodes = x.selectNodes(doc, "./ns:COMPARABLE_ADJUSTMENTS/ns:COMPARABLE_ADJUSTMENT");
		if (nodes.length > 0)
		{
			nodes.forEach((xn) => {
				this.comparableAdjustments.push(new ComparableAdjustment(xn));
			});
		}
		node = x.selectSingleNode(doc, "./ns:COMPARABLE_DETAIL");
		if (node !== null)
				this.comparableDetail = new ComparableDetail(node);
   }

	GetComparableAdjustmentAmount(type, identifier) {
		if (this.comparableAdjustments.length === 0) return null;
		for (var ca of this.comparableAdjustments) {
			if (ca.comparableAdjustmentType === type)
				if (!identifier || ca.unitIdentifier === identifier)
					return ca.comparableAdjustmentAmount;
		}
		return null;
		}

	GetTotalAdjustmentAmount() {
		var amount = 0;
		for (var ca of this.comparableAdjustments) {
			let caa = ca.comparableAdjustmentAmount;
			
			amount += caa.Value;
		}
		return amount;
	}

	GetProximity() {
		var item = "";
		item = this.comparableDetail.proximityToSubjectDistanceLinearMeasure.ToString();
		item = h.addWithSpace(item, h.toEnumText(this.comparableDetail.comparableToSubjectDirectionType));
		return item;
	}

	GetMortgageType() {
		return h.descriptionOrOther(this.comparableDetail.mortgageType, this.comparableDetail.mortgageTypeOtherDescription);
	}

}
